<template>
  <div
    v-for="(page, pageIndex) in paginatedBilling"
    :key="pageIndex"
    class="page mt-3 mb-5"
  >
    <div class="list-container">
      <h1 v-if="pageIndex === 0" class="invoice-title text-center py-1">INVOICE</h1>

      <div class="invoice-container">
        <!-- ✅ ヘッダー部分（1ページ目のみ表示） -->
        <div v-if="pageIndex === 0" class="header">

          <div class="d-flex justify-content-between mb-3">
            <div class="annual-bill-customer-rep mb-0 d-flex">
              <!-- 顧客名(請求先) 御中 -->
              <div class="mb-3">
                <div class="d-flex mb-1">
                  <div>
                    <span class="text-nowrap me-2">Bill To:</span>
                  </div>
                  <div>
                    <h4 class="billing-dear-nm mb-0 align-self-start">
                      <span class="multiline-text">{{ billing.m_customer?.customer_nm }}</span>
                    </h4>
                    <!-- 顧客住所 -->
                    <div v-if="billing.billing_customer_address_display_flg === true">
                      <p v-html="(billing.customer_address || '').replace(/\n/g, '<br>')" class="mb-0 text-start"></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="one-third-block text-end">
              <p v-if="billing.billing_dt_display_flg" class="billing-dt mb-0 text-end pe-0">{{ formatDateEn(billing.billing_dt) }}</p>
              <p class="text-end mb-0"><span>Invoice No.</span> {{ billing.parent_billing_no }}</p>
              <div class="text-end me-2 mb-2">{{ pageIndex + 1 }}/{{ paginatedBilling.length }}</div>
            </div>
          </div>
  
          <div class="middle-title d-flex justify-content-between" style="position: relative">
            <img
              v-if="billing.seal_flg"
              width="80"
              height="80"
              src="../../../../assets/billing_sign_img.png"
              style="cursor: pointer; position: absolute; top: -84px; right: 192px;"
            >
            <div></div>
            <div class="text-end">
              <div class="company-info-block">
                <h4 class="billing-company-nm">
                  <span class="color-billing-company-orange">S</span>oei 
                  <span class="color-billing-company-orange">P</span>lanning 
                  <span class="color-billing-company-orange">C</span>o., Ltd.
                </h4>
                <p class="billing-company-address mb-0 text-start"><span class="me-4">2-38-6</span><span>Yoyogi, Shibuya-ku,</span></p>
                <p class="billing-company-address mb-0 text-start"><span class="me-4">Tokyo,</span><span>151-0053</span></p>
                <p class="billing-company-address mb-0 text-end"><span>Tel：03-3370-8006</span></p>
                <p class="billing-company-address mb-0 text-end"><span>Fax：03-3370-8157</span></p>
              </div>
            </div>
          </div>
        </div>
  
        <!-- ✅ ヘッダー部分（1ページ目のみ表示） -->
        <div v-if="pageIndex === 0" class="total-billing-amount-area mb-2">
          <div>
            <h1 class="total-billing-amount">Total Invoice Amount {{ formatCurrency(grandTotal) }}</h1>
          </div>
          <div v-if="billing.carryover_amount > 0" class="d-flex align-items-center carryover-amount">
            <h5 class="mb-0">Carryover Amount {{ formatCurrencyZero(billing.carryover_amount) }}</h5>
          </div>
        </div>
  
        <!-- ✅ ページ番号（2ページ以降は単体で表示） -->
        <div v-if="pageIndex > 0" class="text-end me-2">{{ pageIndex + 1 }}/{{ paginatedBilling.length }}</div>
  
        <table class="table table-bordered monthly-detail-data">
          <thead>
            <tr>
              <th class="invoice-title text-nowrap">ID</th>
              <th class="invoice-title billing-building-nm text-nowrap">Building</th>
              <!-- <th class="invoice-title text-nowrap">Month</th>
              <th class="invoice-title text-nowrap">Day</th> -->
              <th class="invoice-title text-nowrap">Description</th>
              <th v-if="showBreakdown" class="invoice-title text-nowrap">Breakdown</th>
              <th class="invoice-title text-nowrap">Amount</th>
            </tr>
          </thead>
          <tbody>
            <!-- ▼ 各ページ内の billing 行をループ -->
            <tr v-for="(billingItem, scIndex) in page" :key="scIndex">
              
              <!-- 請求ID -->
              <td>{{ billingItem.billing_no }}</td>
  
              <!-- ▼ 建物列 -->
              <template v-if="!billingItem || Object.keys(billingItem).length === 0">
                <!-- ✅ 空行の場合（ページ補完行）：建物列を空で表示 -->
                <td class="text-start">&nbsp;</td>
              </template>
  
              <template v-else-if="billingItem.work_type === 2">
                <!-- ✅ 追加行はrowspanに含めず常に表示 -->
                <td class="text-start">
                  {{ billingItem.m_building?.building_nm || '' }}
                </td>
              </template>
  
              <template
                v-else-if="groupBuildingsInPage(page)[scIndex]"
              >
                <!-- ✅ 初期データで、建物の最初の出現位置だけ rowspan 表示 -->
                <td
                  class="text-start"
                  :rowspan="groupBuildingsInPage(page)[scIndex].count"
                >
                  {{ billingItem.m_building?.building_nm || '' }}
                </td>
              </template>
  
              <!-- ✅ rowspan 対象の2行目以降は建物列なし -->
  
              <!-- 作業年月 -->
              <!-- <td>{{ billingItem.work_month }}</td> -->
  
              <!-- 作業日（formatDay関数で整形） -->
              <!-- <td>{{ formatDay(billingItem.work_dt) }}</td> -->
  
              <!-- 摘要 -->
              <td class="multiline-text text-start">{{ stripMonthlyBillingLabel(billingItem.work_content) }}</td>
  
              <!-- 内訳 -->
              <td v-if="showBreakdown" class="multiline-text text-start">{{ billingItem.breakdown }}</td>
  
              <!-- 金額（右寄せ通貨） -->
              <td class="text-end">{{ formatCurrency(billingItem.bill_amount) }}</td>
            </tr>
            <!-- ▼ 最終ページなら小計・税・合計を表示 -->
            <template v-if="isLastPage(pageIndex)">
              <!-- 内訳列がある場合は6列、それ以外は5列を colspan に指定 -->
              <tr v-if="billing.tax_rate !== null && billing.tax_rate !== 0">
                <td :colspan="showBreakdown ? 4 : 3" class="invoice-title">Sub Total</td>
                <td class="text-end">{{ formatCurrency(billing.total_amount) }}</td>
              </tr>
              <tr v-if="billing.tax_rate !== null && billing.tax_rate !== 0">
                <td :colspan="showBreakdown ? 4 : 3" class="invoice-title">Consumption Tax {{ billing.tax_rate }}%</td>
                <td class="text-end">{{ formatCurrency(tax) }}</td>
              </tr>
              <tr>
                <td :colspan="showBreakdown ? 4 : 3" class="invoice-title">Total</td>
                <td class="text-end">{{ formatCurrency(noCarryoverTotal) }}</td>
              </tr>
            </template>
          </tbody>
        </table>
  
        <!-- ✅ 振込先情報（最終ページのみ表示） -->
        <div v-if="isLastPage(pageIndex)" class="ms-4">
          <!-- 振込先１(三菱UFJ銀行) -->
          <div class="d-flex">
            <div class="me-5">
              Remittance Address
            </div>
            <div class="ms-5">
              <p class="mb-0">Kabushikigaisha Soei Kikaku</p>
              <p class="mb-0">[(株)創英企画]</p>
              <p class="mb-0">Current Account {{ bankLabels.bank_01.account_no }}</p>
              <p class="mb-0">(当座預金 {{ bankLabels.bank_01.account_no }})</p>
              <p class="mb-0">{{ bankLabels.bank_01.name }} {{ bankLabels.bank_01.branch }}</p>
              <p class="mb-0">(三菱UFJ銀行 新宿中央支店)</p>
              <!-- hidden inputsはそのままでOK（日本語データ送信） -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { savedBillingAmounts } from '@/utils/billingAmounts';
import { computed, defineProps } from 'vue';
import {
  buildConsecutiveBuildingGroups,
  sortMonthlyBillingDetailsByWorkDate,
  stripMonthlyBillingLabel
} from '@/utils/monthlyBillingDetails';

const props = defineProps({
  billing: Object,
  year: Number,
  month: Number
});

const bankLabels = computed(() => ({
  bank_01: {
    bank_display_flg: true,
    name: 'MUFG Bank, Ltd.',
    branch: 'Shinjuku Central Branch',
    type: 'Current Account',
    account_no: props.billing.account_no_01
  }
}));

const paginatedBilling = computed(() => {
  const details = sortMonthlyBillingDetailsByWorkDate(props.billing?.t_customer_monthly_billing_details || []);
  const perPage = 14;
  const pages = [];
  for (let i = 0; i < details.length; i += perPage) {
    const page = details.slice(i, i + perPage);
    while (page.length < perPage) page.push({});
    pages.push(page);
  }
  return pages;
});

const isLastPage = (index) => index === paginatedBilling.value.length - 1;

/**
 * ページ内の billingItem を建物ごとにグループ化。
 * ただし、追加項目（work_type === 2）は含めない。
 * 
 * @param {Array} page - 表示対象の1ページ分の請求明細データ
 * @returns {Object} 建物IDごとの出現位置と行数
 */
const groupBuildingsInPage = (page) => {
  return buildConsecutiveBuildingGroups(page);
};

const showBreakdown = computed(() => {
  return (props.billing?.t_customer_monthly_billing_details || []).some(item => item.breakdown);
});

const formatDateEn = (date) => {
  if (!date) return '';
  const d = new Date(date);
  const day = d.getDate();
  const monthShort = d.toLocaleString('en-US', { month: 'short' });
  const yearShort = d.getFullYear().toString().slice(-2);
  return `${day}-${monthShort}-${yearShort}`;
};

// const formatDay = (date) => {
//   if (!date) return '';
//   return new Date(date).getDate();
// };

const formatCurrency = (val) => {
  return val ? new Intl.NumberFormat('ja-JP', { style: 'currency', currency: 'JPY' }).format(val) : '';
};

const formatCurrencyZero = (val) => {
  return val ? formatCurrency(val) : '¥0';
};

const tax = computed(() => savedBillingAmounts(props.billing).tax_amount);
const noCarryoverTotal = computed(() => savedBillingAmounts(props.billing).current_billing_amount);
const grandTotal = computed(() => savedBillingAmounts(props.billing).billing_total_amount);
</script>

<style scoped>
.list-container {
  padding: 0 !important;
  width: 70%;
  margin: 20px auto;
  border: 1px solid #000;
}

.invoice-title{
  background-color: #77b8de;
  color: #fff;
}

.invoice-container {
  padding: 20px;
}

.header h4.billing-dear-nm {
  font-size: 16px;
  padding: 4px 8px 4px 0;
}

.header .middle-title .billing-greeting,
.header .middle-title .billing-company-nm,
.header .middle-title .billing-company-representative,
.header .middle-title .billing-company-address {
  font-weight: bold;
}

.header .billing-company-nm,
.header .billing-company-representative,
.header .billing-company-address,
.header .text-end p {
  text-align: justify;
  text-justify: inter-ideograph; /* 日本語対応の両端揃え */
  margin-left: auto; /* text-end に合わせて右寄せ */
  margin-right: 0;
  margin-bottom: 0;
  display: block;
  line-height: 0.8; /* デフォルトは 1.5〜1.6 のことが多い */
}

.color-billing-company-orange {
  color: #ff6600;
}

.header .billing-company-nm::after,
.header .billing-company-representative::after,
.header .billing-company-address::after,
.header .text-end p::after {
  content: '';
  display: inline-block;
  width: 100%;
}

.header .middle-title .billing-greeting{
  font-size: 20px;
  margin-left: 20px;
}
.header .billing-company-nm { font-size: 24px; }
.header .billing-company-representative { font-size: 18px; }
.header .company-regist-no { font-size: 16px; }

.button-area {
  text-align: right;
  margin-bottom: 20px;
}

.button-area .btn {
  margin-left: 10px;
}

.total-billing-amount-area .total-billing-amount{
  display: inline-block;
}

.monthly-detail-data {
  margin: 20px auto;
  width: 100%;
  border-collapse: collapse;
}

.monthly-detail-data th, 
.monthly-detail-data td {
  border: 1px solid #000;
  padding: 8px;
  text-align: center;
  font-size: 14px;
  height: 38px;
}

.monthly-detail-data th.billing-building-nm {
  min-width: 200px !important;
}

.monthly-detail-data th.month-day-width{
  width: 36px;
}

.monthly-detail-data th.month-data-header {
  background-color: #f0f8ff;
  font-weight: bold;
}

.billing-bank-info{
  font-size: 15px;
  font-weight: bold;
}

.w-half{
  width: 50% !important;
}
</style>
